function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSanta = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 64 64",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5
  },
  width: "1em",
  height: "1em",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M27.237 46.426c2.577-13.041 13.36-21.857 26.343-22.956 6.323-.536 14.447-.195 20.041 2.576 6.154 3.049 8.316 3.88 14.465 8.64 1.518 1.175 4.31 4.328 5.12 6.063 1.505 3.222 1.627 7.159 1.354 10.743-.41 5.388-1.418 10.327-1.454 15.782-.03 4.383.137 8.763.287 13.152.059 1.736.229 4.498-.804 6.033-.266.394-.471 1-.942 1.054-3.555.403-3.885-1.215-4.842-3.715-1.013-2.647-2.086-7.105-2.293-9.923-.143-1.953.027-2.36-1.728-3.368-.954-.548-1.608-2.994-2.157-3.517-1.239-1.182-2.048-2.157-3.329-3.295-1.378-1.223-2.288-1.976-3.995-2.685-4.846-2.014-10.112-2.677-15.298-3.158-7.727-.716-14.951-.925-22.409 1.741-2.971 1.063-6.041 2.468-8.656 4.236-.847.574-1.675 1.206-2.39 1.941-.128.132-.582.845-.728.864-.062.007-.212-1.649-.223-1.806-.14-2.005-.073-4.089-.097-6.098-.04-3.379-.128-6.143.784-9.552.36-1.348 1.527-2.203 2.951-2.752Z",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: "4.69px"
  },
  transform: "matrix(.4261 0 0 .4261 4.737 5.224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.714 46.688c2.809-1.421 6.388-2.982 9.433-3.809 9.863-2.679 20.174-1.539 30.147-.126 6.953.986 14.55 2.786 17.938 9.774.892 1.84.84.653.563 5.981-.21 4.036-1.21 8.397-.938 12.45",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: "4.69px"
  },
  transform: "matrix(.4261 0 0 .4261 4.737 5.224)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.521 88.442c4.96 0 9.289 4.141 9.289 9.185 0 5.044-4.027 9.139-8.988 9.139-4.96 0-8.987-4.095-8.987-9.139a9.178 9.178 0 0 1 3.654-7.355",
  style: {
    fill: "#ebebeb",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: "4.69px"
  },
  fill: "none",
  transform: "matrix(.4261 0 0 .4261 3.365 4.026)"
}));

const ForwardRef = /*#__PURE__*/forwardRef(SvgSanta);
export default ForwardRef;